(<template>
  <div>
    <el-upload name="audio"
               :with-credentials="true"
               :action="uploadUrl"
               :on-preview="handlePreview"
               :on-remove="handleRemove"
               :limit="1"
               :on-exceed="handleExceed"
               :on-success="handleSuccess"
               :file-list="uploadedAudio"
               accept="audio/mpeg">
      <el-button size="small" type="primary">
        <span v-translate>Upload</span>
      </el-button>
      <div slot="tip" class="el-upload__tip">{{uploadTooltip}}</div>
    </el-upload>
    <el-dialog :visible.sync="isDialogVisible" :append-to-body="true">
      <audio v-if="isDialogVisible" controls class="audio-player">
        <source :src="dialogAudioUrl" type="audio/mpeg" />
      </audio>
    </el-dialog>
  </div>
</template>)

(<script>
export default {
  name: 'audio-uploader',
  props: ['loaded-audio', 'lang'],
  data () {
    var uploadedAudio = []
    if (this.loadedAudio) {
      uploadedAudio.push({
        name: this.loadedAudio.split('/').pop(),
        url: this.loadedAudio
      })
    }
    var uploadTooltip = ''
    switch (this.lang) {
      case 'hu':
        uploadTooltip = this.$gettext('Upload hungarian audio')
        break
      case 'en':
        uploadTooltip = this.$gettext('Upload english audio')
        break
      case 'ro':
        uploadTooltip = this.$gettext('Upload romanian audio')
        break
    }
    return {
      uploadTooltip,
      uploadUrl: `${process.env.SERVER_URL}/audios`,
      dialogAudioUrl: '',
      isDialogVisible: false,
      uploadedAudio
    }
  },
  methods: {
    handleSuccess (response) {
      this.$emit('audio-file-changed', response.split('/').pop())
    },
    handleRemove (file) {
      this.$emit('audio-file-removed', file.response)
    },
    handlePreview (file) {
      this.dialogAudioUrl = file.url
      this.isDialogVisible = true
    },
    handleExceed () {
      this.$message({
        type: 'warning',
        message: this.$gettext('Only one file can be uploaded!')
      })
    }
  }
}
</script>)

(<style>
.audio-player {
  width: 100%;
}
</style>)



// WEBPACK FOOTER //
// src/components/Audio-Uploader.vue